import React from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@alm/flow-ds/components";

import { ActivityInstance } from "records/ActivityInstance";
import CardColumn from "components/CardColumn";
import InstancesMenu from "./InstancesMenu";
import { useGetConvertedUserTime } from "hooks/useTimezone";

function InstancesCard({
	id,
	workflow,
	status,
	created,
	createdBy,
	isActive,
	isChecked,
	loading,
	handleCheckboxClick,
}: ActivityInstance) {
	const { t } = useTranslation();

	const createdConverted = useGetConvertedUserTime(created);

	return (
		<>
			<CardColumn width="none">
				<Checkbox
					id={`checkbox__${id}`}
					checked={isChecked}
					value={isChecked as unknown as string}
					onChange={handleCheckboxClick(id)}
					label=""
					ariaLabel={`Select instance ${id}`}
					className="activity-instances-checkbox"
				/>
			</CardColumn>
			<CardColumn className="activity-instances-card__id" width="xl">
				{id}
			</CardColumn>
			<CardColumn
				className="activity-instances-card__workflow"
				width="xl">
				{workflow || t("main.text.na")}
			</CardColumn>
			<CardColumn className="activity-instances-card__status" width="sm">
				{status || t("main.text.na")}
			</CardColumn>
			<CardColumn width="lg">
				<div className="activity-instances-card--mobile--heading__created">
					{t("main.activityInstances.headings.created")}
				</div>
				<div>{createdConverted}</div>
			</CardColumn>
			<CardColumn
				className="activity-instances-card__created-by"
				width="sm">
				{createdBy || t("main.text.na")}
			</CardColumn>
			<CardColumn className="activity-instances-card__menu" width="xs">
				<InstancesMenu
					id={id}
					isActive={isActive || status === "Active"}
					loading={loading}
				/>
			</CardColumn>
		</>
	);
}

export default React.memo(
	InstancesCard,
	(prevProps, nextProps) =>
		prevProps.id === nextProps.id &&
		prevProps.isChecked === nextProps.isChecked &&
		prevProps.status === nextProps.status
);
